import { ReportData, FileAttachment } from './reportTypes';

/** API / önbellek bazen boolean yerine 0|1 veya "true"|"false" döndürebilir; rapor eşlemesi için tek tipe indirger. */
export const isAfterMeasuresValue = (value: unknown): boolean =>
    value === true || value === 'true' || value === 1 || value === '1';

export const getRiskLevelColor = (riskLevel: number): { backgroundColor: string, color: string } => {
    if (riskLevel < 3) return { backgroundColor: '#e0e0e0', color: '#000000' }; // DÜŞÜK  (r < 3)
    if (riskLevel >= 3 && riskLevel <= 10) return { backgroundColor: '#fff176', color: '#000000' }; // ORTA   (3 ≤ r ≤ 10)
    if (riskLevel > 10 && riskLevel < 20) return { backgroundColor: '#ffb74d', color: '#000000' }; // YÜKSEK (10 < r < 20)
    return { backgroundColor: '#ef5350', color: '#FFFFFF' }; // KRİTİK (r ≥ 20)
};

export const getRiskLevelText = (riskLevel: number): string => {
    if (riskLevel < 3) return 'DÜŞÜK';
    if (riskLevel >= 3 && riskLevel <= 10) return 'ORTA';
    if (riskLevel > 10 && riskLevel < 20) return 'YÜKSEK';
    return 'KRİTİK';
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Failed to convert blob to base64'));
            }
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
    });
};

export const getCoverPhotoId = (
    reportData: ReportData,
    availableAttachments?: Record<string, string>,
): string | null => {
    const pinAttachments = reportData?.pinInfo?.fileAttachments ?? [];
    if (!pinAttachments.length) return null;

    const coverPrefix = `cover${String(reportData.pinInfo.Id ?? '').toLowerCase()}`;
    const candidates = [...pinAttachments]
        .filter((attachment) => {
            const fileName = String(attachment.fileName ?? '').toLowerCase();
            return fileName.startsWith(coverPrefix)
                && (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png'));
        })
        .reverse();

    if (!candidates.length) return null;
    if (!availableAttachments) return candidates[0]?.id || null;

    const resolved = candidates.find((attachment) => !!availableAttachments[attachment.id]);
    return resolved?.id || null;
};

export const getMapImage = (reportData: ReportData): string | null => {
    const pinAttachments = reportData.pinInfo.fileAttachments || [];

    const stdGuid = reportData.pinInfo.reportLocationPng?.trim();
    if (stdGuid) {
        const g = stdGuid.toLowerCase();
        const match = pinAttachments.find((a) => (a.id || '').toLowerCase() === g);
        if (match) {
            return match.id;
        }
    }

    // Eğer ReportLocationPng yoksa, eski yöntemle harita dosyasını bul
    if (!pinAttachments.length) return null;
    const mapFiles = pinAttachments.filter((attachment) => {
        const n = attachment.fileName.toLowerCase();
        return n.includes('harita') && !n.includes('harita-uydu');
    });
    if (mapFiles.length === 0) return null;
    const getMapNumber = (fileName: string) => {
        const match = fileName.match(/harita-(\d+)/i);
        return match ? parseInt(match[1]) : 0;
    };
    const latestMap = mapFiles.reduce((latest, current) => {
        const latestNum = getMapNumber(latest.fileName);
        const currentNum = getMapNumber(current.fileName);
        return currentNum > latestNum ? current : latest;
    }, mapFiles[0]);
    return latestMap?.id || null;
};

export const getSatelliteMapImage = (reportData: ReportData): string | null => {
    const pinAttachments = reportData.pinInfo.fileAttachments || [];

    const satGuid = reportData.pinInfo.reportLocationSatellitePng?.trim();
    if (satGuid) {
        const g = satGuid.toLowerCase();
        const match = pinAttachments.find((a) => (a.id || '').toLowerCase() === g);
        if (match) {
            return match.id;
        }
    }

    if (!pinAttachments.length) return null;
    const satFiles = pinAttachments.filter((a) =>
        a.fileName.toLowerCase().includes('harita-uydu'),
    );
    if (satFiles.length === 0) return null;
    const getTs = (fileName: string) => {
        const m = fileName.match(/(\d{10,})/);
        return m ? parseInt(m[1], 10) : 0;
    };
    return satFiles.reduce((latest, cur) =>
        getTs(cur.fileName) > getTs(latest.fileName) ? cur : latest,
    ).id;
};